// import React, { useEffect, useState, useCallback } from "react";

// /* -------------------- HELPERS -------------------- */

// const API_URL = "https://api.glocart.in/pages/api/api/orders";

// function formatDate(s) {
//   if (!s) return "";
//   try {
//     return new Date(s).toLocaleString();
//   } catch {
//     return s;
//   }
// }

// /* -------------------- ITEM THUMB -------------------- */

// const ItemThumb = ({ item }) => {
//   const uri = item.image || item.image_1 || "https://via.placeholder.com/120";

//   return (
//     <div style={styles.thumbWrap}>
//       <img src={uri} alt="" style={styles.thumb} />
//       <div style={styles.thumbName}>{item.name}</div>
//       <div style={styles.thumbQty}>x{item.quantity}</div>
//     </div>
//   );
// };

// /* -------------------- ORDER CARD -------------------- */

// const OrderCard = ({ order, onPress }) => {
//   const addr = order.address || {};
//   const totals = order.totals || {};

//   return (
//     <div style={styles.card} onClick={() => onPress(order)}>
//       <div style={styles.cardHeader}>
//         <div>
//           <div style={styles.orderNo}>Order #{order.id}</div>
//           <div style={styles.orderDate}>{formatDate(order.created_at)}</div>
//         </div>

//         <div
//           style={{
//             ...styles.badge,
//             ...(order.is_paid ? styles.paidBadge : styles.pendingBadge),
//           }}
//         >
//           Payment: {order.is_paid === 1 ? "Paid ✅" : "Not Paid ❌"}
//         </div>
//       </div>

//       <div style={styles.cardBody}>
//         <div style={styles.leftCol}>
//           <div style={styles.name}>
//             {addr.firstName || addr.fullName || "Customer"}
//           </div>
//           <div style={styles.address}>
//             {addr.fullAddress || addr.address || "—"}
//           </div>

//           <div style={styles.metaRow}>
//             <span style={styles.metaLabel}>Delivery:</span>
//             <span style={styles.metaValue}>
//               {order.delivery || "Standard"}
//             </span>
//           </div>
//         </div>

//         <div style={styles.rightCol}>
//           <div style={styles.total}>
//             ₹ {totals.grandTotal ?? totals.subtotal ?? 0}
//           </div>
//           <div style={styles.ship}>
//             Ship ₹{totals.shippingCharge ?? 0}
//           </div>

//           <button
//             style={styles.viewBtn}
//             onClick={(e) => {
//               e.stopPropagation();
//               onPress(order);
//             }}
//           >
//             View
//           </button>
//         </div>
//       </div>

//       <div style={styles.itemsRow}>
//         <div style={{ display: "flex", overflowX: "auto" }}>
//           {(order.cartItems || []).map((item, i) => (
//             <ItemThumb key={i} item={item} />
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// /* -------------------- MAIN SCREEN -------------------- */

// export default function OrdersScreen() {
//   const [orders, setOrders] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [userData, setUserData] = useState(null);

//   /* -------------------- USER DATA -------------------- */

//   useEffect(() => {
//     const data = localStorage.getItem("userInfo");
//     if (data) setUserData(JSON.parse(data));
//   }, []);

//   /* -------------------- FETCH DATA -------------------- */

//   const fetchData = useCallback(async () => {
//     try {
//       setError(null);

//       const [ordersRes, productsRes] = await Promise.all([
//         fetch(API_URL),
//         fetch("https://api.glocart.in/pages/api/products/get"),
//       ]);

//       const ordersData = await ordersRes.json();
//       const productsData = await productsRes.json();

//       const userId = userData?.userId;

//       if (Array.isArray(ordersData)) {
//         setOrders(ordersData.filter((o) => o.user_id === userId));
//       }

//       setProducts(Array.isArray(productsData) ? productsData : []);
//     } catch (err) {
//       setError("Failed to load");
//     } finally {
//       setLoading(false);
//       setRefreshing(false);
//     }
//   }, [userData]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   /* -------------------- PRODUCT MAP -------------------- */

//   const productMap = {};
//   const variantMap = {};

//   products.forEach((p) => {
//     productMap[p.id] = p;
//     (p.variants || []).forEach((v) => {
//       variantMap[v.id] = { ...v, product: p };
//     });
//   });

//   const enrichOrder = (order) => ({
//     ...order,
//     cartItems: (order.cartItems || []).map((ci) => {
//       const product = productMap[ci.product_id];
//       const variant = variantMap[ci.v_id];
//       return {
//         ...ci,
//         product,
//         variant,
//         image: product?.image_1 || product?.image,
//         name: product?.name || "Unknown",
//       };
//     }),
//   });

//   /* -------------------- UI -------------------- */

//   if (loading) {
//     return <div style={styles.center}>Loading...</div>;
//   }

//   return (
//     <div style={styles.container}>
//       {error && <div style={styles.center}>{error}</div>}

//       {orders.map((order) => (
//         <OrderCard
//           key={order.id}
//           order={enrichOrder(order)}
//           onPress={setSelectedOrder}
//         />
//       ))}

//       {/* MODAL */}
//       {selectedOrder && (
//         <div style={styles.modalOverlay}>
//           <div style={styles.modal}>
//             <h2>Order #{selectedOrder.id}</h2>

//             {(selectedOrder.cartItems || []).map((ci, i) => (
//               <div key={i} style={{ marginTop: 16 }}>
//                 <strong>{ci.product?.name}</strong>
//                 <br />
//                 <img src={ci.image} style={{ width: 120 }} alt="" />
//                 <div>Qty: {ci.quantity}</div>
//               </div>
//             ))}

//             <button
//               style={styles.closeBtn}
//               onClick={() => setSelectedOrder(null)}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// /* -------------------- INLINE STYLES -------------------- */

// const styles = {
//   container: { padding: 12, background: "#f6f7fb", minHeight: "100vh" },
//   center: { textAlign: "center", marginTop: 50 },

//   card: {
//     background: "#fff",
//     borderRadius: 12,
//     padding: 12,
//     marginBottom: 12,
//     boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//     cursor: "pointer",
//   },

//   cardHeader: {
//     display: "flex",
//     justifyContent: "space-between",
//   },

//   orderNo: { fontWeight: 700 },
//   orderDate: { fontSize: 12, color: "#666" },

//   badge: {
//     padding: "6px 10px",
//     borderRadius: 20,
//     fontWeight: 700,
//   },

//   paidBadge: { background: "#e8f6ef", color: "#0a7a4a" },
//   pendingBadge: { background: "#fff4e6" },

//   cardBody: { display: "flex", marginTop: 10 },
//   leftCol: { flex: 1 },
//   rightCol: { width: 120, textAlign: "right" },

//   name: { fontWeight: 700 },
//   address: { color: "#666", fontSize: 13, marginTop: 6 },

//   metaRow: { marginTop: 8 },
//   metaLabel: { fontSize: 12 },
//   metaValue: { marginLeft: 6, fontWeight: 600 },

//   total: { fontWeight: 800, fontSize: 18 },
//   ship: { fontSize: 12, color: "#666" },

//   viewBtn: {
//     marginTop: 8,
//     padding: "6px 12px",
//     background: "#111",
//     color: "#fff",
//     borderRadius: 8,
//     border: "none",
//   },

//   itemsRow: { marginTop: 12 },

//   thumbWrap: {
//     width: 90,
//     marginRight: 10,
//     textAlign: "center",
//   },

//   thumb: {
//     width: 80,
//     height: 80,
//     borderRadius: 8,
//     background: "#eee",
//   },

//   thumbName: { fontSize: 12, marginTop: 6 },
//   thumbQty: { fontSize: 12, color: "#666" },

//   modalOverlay: {
//     position: "fixed",
//     inset: 0,
//     background: "rgba(0,0,0,0.5)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },

//   modal: {
//     background: "#fff",
//     padding: 20,
//     borderRadius: 10,
//     width: 400,
//     maxHeight: "80vh",
//     overflowY: "auto",
//   },

//   closeBtn: {
//     marginTop: 20,
//     padding: 10,
//     background: "#000",
//     color: "#fff",
//     borderRadius: 8,
//     border: "none",
//     width: "100%",
//   },
// };

// import React, { useEffect, useState, useCallback } from "react";

// const OrderScreen = () => {
//   const [orders, setOrders] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [userData, setUserData] = useState(null);

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [refreshing, setRefreshing] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);

//   /* ---------------- USER DATA (AsyncStorage → localStorage) ---------------- */
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const data = sessionStorage.getItem("userData");
//         console.log('this is data',data)
//         if (data) {
//           setUserData(JSON.parse(data));
//         }
//       } catch (err) {
//         console.error("Error fetching user data", err);
//       }
//     };
//     fetchUserData();
//   }, []);

//   /* ---------------- FETCH ORDERS + PRODUCTS ---------------- */
//   const fetchData = useCallback(async () => {
//     try {
//       setError(null);
//       setLoading(true);

//       const [ordersRes, productsRes] = await Promise.all([
//         fetch("https://api.glocart.in/pages/api/api/orders"),
//         fetch("https://api.glocart.in/pages/api/products/get"),
//       ]);

//       if (!ordersRes.ok || !productsRes.ok) {
//         throw new Error("Network error");
//       }

//       const ordersData = await ordersRes.json();
//       const productsData = await productsRes.json();

//       const userId = userData?.id;
//       console.log("this is userIddd", userId);

//       if (Array.isArray(ordersData)) {
//         const filtered = ordersData.filter(o => o.user_id === userId);
//         setOrders(filtered);
//       } else {
//         setOrders([]);
//       }

//       setProducts(Array.isArray(productsData) ? productsData : []);
//     } catch (err) {
//       setError(err.message || "Failed to load");
//     } finally {
//       setLoading(false);
//       setRefreshing(false);
//     }
//   }, [userData]);

//   useEffect(() => {
//     if (userData) fetchData();
//   }, [userData, fetchData]);

//   const onRefresh = () => {
//     setRefreshing(true);
//     fetchData();
//   };

//   /* ---------------- HELPERS ---------------- */
//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });

//   const enrichOrder = (order) => order; // kept as-is as per your code

//   /* ---------------- ITEM THUMB ---------------- */
//   const ItemThumb = ({ item }) => (
//     <div style={{ marginRight: 8 }}>
//       <img
//         src={item.image || "https://via.placeholder.com/60"}
//         alt=""
//         style={{ width: 60, height: 60, borderRadius: 6 }}
//       />
//     </div>
//   );

//   /* ---------------- ORDER CARD ---------------- */
//   const OrderCard = ({ order, onPress }) => {
//     const addr = order.address || {};
//     const totals = order.totals || {};

//     return (
//       <div
//         onClick={() => onPress(order)}
//         style={{
//           border: "1px solid #e5e5e5",
//           borderRadius: 12,
//           padding: 14,
//           background: "#fff",
//           cursor: "pointer",
//         }}
//       >
//         {/* Header */}
//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <div>
//             <p style={{ fontWeight: 600 }}>Order #{order.id}</p>
//             <p style={{ fontSize: 12, color: "#666" }}>
//               {formatDate(order.created_at)}
//             </p>
//           </div>

//           <div
//             style={{
//               padding: "4px 10px",
//               borderRadius: 20,
//               fontSize: 12,
//               background: order.is_paid ? "#d4f7dc" : "#ffe1e1",
//             }}
//           >
//             Payment: {order.is_paid === 1 ? "Paid ✅" : "Not Paid ❌"}
//           </div>
//         </div>

//         {/* Body */}
//         <div style={{ display: "flex", marginTop: 12 }}>
//           <div style={{ flex: 1 }}>
//             <p style={{ fontWeight: 500 }}>
//               {addr.firstName || addr.fullName || "Customer"}
//             </p>
//             <p style={{ fontSize: 13, color: "#555" }}>
//               {addr.fullAddress || addr.address || "—"}
//             </p>
//             <p style={{ fontSize: 13 }}>
//               <b>Delivery:</b> {order.delivery || "Standard"}
//             </p>
//           </div>

//           <div style={{ textAlign: "right" }}>
//             <p style={{ fontSize: 16, fontWeight: 600 }}>
//               ₹ {totals.grandTotal ?? totals.subtotal ?? 0}
//             </p>
//             <p style={{ fontSize: 13 }}>
//               Ship ₹{totals.shippingCharge ?? 0}
//             </p>
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onPress(order);
//               }}
//               style={{
//                 marginTop: 6,
//                 padding: "6px 12px",
//                 borderRadius: 6,
//                 border: "none",
//                 background: "#4B0082",
//                 color: "#fff",
//                 cursor: "pointer",
//               }}
//             >
//               View
//             </button>
//           </div>
//         </div>

//         {/* Items */}
//         <div style={{ display: "flex", marginTop: 12, overflowX: "auto" }}>
//           {(order.cartItems || []).map((item, i) => (
//             <ItemThumb key={i} item={item} />
//           ))}
//         </div>
//       </div>
//     );
//   };

//   /* ---------------- UI ---------------- */
// //   if (loading) return <p>Loading...</p>;
// //   if (error) return <p>{error}</p>;

//   return (
//     <div style={{ padding: 12 }}>
//       <button
//         onClick={onRefresh}
//         style={{
//           marginBottom: 12,
//           padding: "8px 16px",
//           borderRadius: 6,
//           border: "none",
//           background: "#ddd",
//           cursor: "pointer",
//         }}
//       >
//         Refresh
//       </button>

//       {orders.length === 0 ? (
//         <div style={{ textAlign: "center", marginTop: 40 }}>
//           No paid orders yet.
//         </div>
//       ) : (
//         orders.map(enrichOrder).map((item) => (
//           <div key={item.id} style={{ marginBottom: 12 }}>
//             <OrderCard order={item} onPress={setSelectedOrder} />
//           </div>
//         ))
//       )}
//     </div>
//   );
// };

// export default OrderScreen;


// import React, { useEffect, useState, useCallback } from "react";

// const OrderScreen = () => {
//   const [orders, setOrders] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [userData, setUserData] = useState(null);

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [refreshing, setRefreshing] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);

//   /* ---------------- USER DATA (sessionStorage) ---------------- */
//   useEffect(() => {
//     try {
//       const data = sessionStorage.getItem("userData");
//       if (data) {
//         const parsed = JSON.parse(data);
//         setUserData(parsed);
//       }
//     } catch (err) {
//       console.error("Error fetching user data", err);
//     }
//   }, []);

//   /* ---------------- FETCH ORDERS + PRODUCTS ---------------- */
//   const fetchData = useCallback(async () => {
//     if (!userData?.id) return;

//     try {
//       setError(null);
//       setLoading(true);

//       const [ordersRes, productsRes] = await Promise.all([
//         fetch("https://api.glocart.in/pages/api/api/orders"),
//         fetch("https://api.glocart.in/pages/api/products/get"),
//       ]);

//       if (!ordersRes.ok || !productsRes.ok) {
//         throw new Error("Network error");
//       }

//       const ordersData = await ordersRes.json();
//       const productsData = await productsRes.json();

//       const userId = userData.id;

//       if (Array.isArray(ordersData)) {
//         const filteredOrders = ordersData.filter(
//           (o) => o.user_id === userId
//         );
//         setOrders(filteredOrders);
//       } else {
//         setOrders([]);
//       }

//       setProducts(Array.isArray(productsData) ? productsData : []);
//     } catch (err) {
//       setError(err.message || "Failed to load");
//     } finally {
//       setLoading(false);
//       setRefreshing(false);
//     }
//   }, [userData]);

//   useEffect(() => {
//     if (userData) {
//       fetchData();
//     }
//   }, [userData, fetchData]);

//   const onRefresh = () => {
//     setRefreshing(true);
//     fetchData();
//   };

//   /* ---------------- HELPERS ---------------- */
//   const formatDate = (date) => {
//     if (!date) return "";
//     return new Date(date).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const enrichOrder = (order) => order; // kept exactly as requested

//   /* ---------------- ITEM THUMB ---------------- */
//   const ItemThumb = ({ item }) => (
//     <div style={{ marginRight: 8 }}>
//       <img
//         src={item.image || "https://via.placeholder.com/60"}
//         alt=""
//         style={{
//           width: 60,
//           height: 60,
//           borderRadius: 6,
//           objectFit: "cover",
//         }}
//       />
//     </div>
//   );

//   /* ---------------- ORDER CARD ---------------- */
//   const OrderCard = ({ order, onPress }) => {
//     const addr = order.address || {};
//     const totals = order.totals || {};

//     return (
//       <div
//         onClick={() => onPress(order)}
//         style={{
//           border: "1px solid #e5e5e5",
//           borderRadius: 12,
//           padding: 14,
//           background: "#fff",
//           cursor: "pointer",
//         }}
//       >
//         {/* Header */}
//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <div>
//             <p style={{ fontWeight: 600, margin: 0 }}>
//               Order #{order.id}
//             </p>
//             <p style={{ fontSize: 12, color: "#666", margin: 0 }}>
//               {formatDate(order.created_at)}
//             </p>
//           </div>

//           <div
//             style={{
//               padding: "4px 10px",
//               borderRadius: 20,
//               fontSize: 12,
//               background: order.is_paid ? "#d4f7dc" : "#ffe1e1",
//             }}
//           >
//             Payment: {order.is_paid === 1 ? "Paid ✅" : "Not Paid ❌"}
//           </div>
//         </div>

//         {/* Body */}
//         <div style={{ display: "flex", marginTop: 12 }}>
//           <div style={{ flex: 1 }}>
//             <p style={{ fontWeight: 500, margin: 0 }}>
//               {addr.firstName || addr.fullName || "Customer"}
//             </p>
//             <p style={{ fontSize: 13, color: "#555", margin: "4px 0" }}>
//               {addr.fullAddress || addr.address || "—"}
//             </p>
//             <p style={{ fontSize: 13, margin: 0 }}>
//               <b>Delivery:</b> {order.delivery || "Standard"}
//             </p>
//           </div>

//           <div style={{ textAlign: "right" }}>
//             <p style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>
//               ₹ {totals.grandTotal ?? totals.subtotal ?? 0}
//             </p>
//             <p style={{ fontSize: 13, margin: "4px 0" }}>
//               Ship ₹{totals.shippingCharge ?? 0}
//             </p>

//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onPress(order);
//               }}
//               style={{
//                 marginTop: 6,
//                 padding: "6px 12px",
//                 borderRadius: 6,
//                 border: "none",
//                 background: "#4B0082",
//                 color: "#fff",
//                 cursor: "pointer",
//               }}
//             >
//               View
//             </button>
//           </div>
//         </div>

//         {/* Items */}
//         <div
//           style={{
//             display: "flex",
//             marginTop: 12,
//             overflowX: "auto",
//           }}
//         >
//           {(order.cartItems || []).map((item, i) => (
//             <ItemThumb key={i} item={item} />
//           ))}
//         </div>
//       </div>
//     );
//   };

//   /* ---------------- UI ---------------- */
//   if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;
//   if (error) return <p style={{ textAlign: "center" }}>{error}</p>;

//   return (
//     <div style={{ padding: 12 }}>
//       <button
//         onClick={onRefresh}
//         disabled={refreshing}
//         style={{
//           marginBottom: 12,
//           padding: "8px 16px",
//           borderRadius: 6,
//           border: "none",
//           background: "#ddd",
//           cursor: "pointer",
//         }}
//       >
//         {refreshing ? "Refreshing..." : "Refresh"}
//       </button>

//       {orders.length === 0 ? (
//         <div style={{ textAlign: "center", marginTop: 40 }}>
//           No paid orders yet.
//         </div>
//       ) : (
//         orders.map(enrichOrder).map((item) => (
//           <div key={item.id} style={{ marginBottom: 12 }}>
//             <OrderCard order={item} onPress={setSelectedOrder} />
//           </div>
//         ))
//       )}
//     </div>
//   );
// };

// export default OrderScreen;



import React, { useEffect, useState, useCallback } from "react";
import Modal from "react-modal";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";

Modal.setAppElement("#root");

/* ---------------- HELPERS ---------------- */
const formatDate = (s) => {
    if (!s) return "";
    try {
        return new Date(s).toLocaleString();
    } catch {
        return s;
    }
};

const OrdersScreen = () => {
    const [orders, setOrders] = useState([]);
    const [products, setProducts] = useState([]);
    const [userData, setUserData] = useState(null);

    const [loading, setLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);
    const [error, setError] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState(null);


    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };

    /* ---------------- USER DATA (sessionStorage) ---------------- */
    useEffect(() => {
        const data = sessionStorage.getItem("userData");
        if (data) {
            setUserData(JSON.parse(data));
        }
    }, []);

    /* ---------------- FETCH DATA ---------------- */
    const fetchData = useCallback(async () => {
        if (!userData?.id) return;

        try {
            setError(null);
            setLoading(true);

            const [ordersRes, productsRes] = await Promise.all([
                fetch("https://api.glocart.in/pages/api/api/orders"),
                fetch("https://api.glocart.in/pages/api/products/get"),
            ]);

            if (!ordersRes.ok || !productsRes.ok) throw new Error("Network error");

            const ordersData = await ordersRes.json();
            const productsData = await productsRes.json();

            const filteredOrders = Array.isArray(ordersData)
                ? ordersData.filter((o) => o.user_id === userData.id)
                : [];

            setOrders(filteredOrders);
            setProducts(Array.isArray(productsData) ? productsData : []);
        } catch (err) {
            setError(err.message || "Failed to load");
        } finally {
            setLoading(false);
            setRefreshing(false);
        }
    }, [userData]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const onRefresh = () => {
        setRefreshing(true);
        fetchData();
    };

    /* ---------------- PRODUCT MAP ---------------- */
    const productMap = {};
    const variantMap = {};

    products.forEach((p) => {
        productMap[p.id] = p;
        (p.variants || []).forEach((v) => {
            variantMap[v.id] = { ...v, product: p };
        });
    });

    // const enrichOrder = (order) => ({
    //     ...order,
    //     cartItems: (order.cartItems || []).map((ci) => {
    //         const product = productMap[ci.product_id];
    //         const variant = variantMap[ci.v_id];
    //         return {
    //             ...ci,
    //             product,
    //             variant,
    //             image:
    //                 product?.image_1 ||
    //                 product?.image ||
    //                 "https://via.placeholder.com/120",
    //             name: product?.name || "Unknown",
    //         };
    //     }),
    // });
    const enrichOrder = (order) => {
  const enrichedItems = (order.cartItems || []).map(ci => {
    const product = productMap[ci.productId];   // ✅ FIX
    const variant = variantMap[ci.variantId];   // ✅ FIX

    return {
      ...ci,
      product,
      variant,

      // 🔥 PRIORITY: always use API image first
      image: ci.image_1 || product?.image_1 || product?.image || "https://via.placeholder.com/120",

      // 🔥 better fallback
      name: ci.productName || product?.name || "Unknown",
    };
  });

  return { ...order, cartItems: enrichedItems };
};

    /* ---------------- ITEM THUMB ---------------- */
    const ItemThumb = ({ item }) => (
        <div style={{ width: 90, marginRight: 10, textAlign: "center" }}>
            <img
                src={item.image}
                alt=""
                style={{
                    width: 80,
                    height: 80,
                    borderRadius: 8,
                    background: "#eee",
                    objectFit: "cover",
                }}
            />
            <div style={{ fontSize: 12, marginTop: 6 }}>{item.name}</div>
            <div style={{ fontSize: 12, color: "#666" }}>x{item.quantity}</div>
        </div>
    );

    /* ---------------- ORDER CARD ---------------- */
    const OrderCard = ({ order }) => {
        const addr = order.address || {};
        const totals = order.totals || {};

        return (
            <div
                onClick={() => setSelectedOrder(order)}
                style={{
                    background: "#fff",
                    borderRadius: 12,
                    padding: 12,
                    boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
                    cursor: "pointer",
                }}
            >
                {/* Header */}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>
                        <div style={{ fontWeight: 700 }}>Order #{order.id}</div>
                        <div style={{ fontSize: 12, color: "#666" }}>
                            {formatDate(order.created_at)}
                        </div>
                    </div>

                    <div
                        style={{
                            padding: "6px 12px",
                            borderRadius: 20,
                            background: order.is_paid ? "#e8f6ef" : "#fff4e6",
                            fontWeight: 700,
                            fontSize: 12,
                        }}
                    >
                        Payment: {order.is_paid ? "Paid ✅" : "Not Paid ❌"}
                    </div>
                </div>

                {/* Body */}
                <div style={{ display: "flex", marginTop: 10 }}>
                    <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 700 }}>
                            {addr.firstName || addr.fullName || "Customer"}
                        </div>
                        <div style={{ fontSize: 13, color: "#666", marginTop: 6 }}>
                            {addr.fullAddress || addr.address || "—"}
                        </div>
                        <div style={{ fontSize: 12, marginTop: 8 }}>
                            <b>Delivery:</b> {order.delivery || "Standard"}
                        </div>
                    </div>

                    <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 18, fontWeight: 800 }}>
                            ₹ {totals.grandTotal ?? totals.subtotal ?? 0}
                        </div>
                        <div style={{ fontSize: 12, color: "#666" }}>
                            Ship ₹{totals.shippingCharge ?? 0}
                        </div>

                        <button
                            style={{
                                marginTop: 8,
                                background: "#111",
                                color: "#fff",
                                padding: "6px 12px",
                                borderRadius: 8,
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            View
                        </button>
                    </div>
                </div>

                {/* Items */}
                <div style={{ display: "flex", marginTop: 12, overflowX: "auto" }}>
                    {(order.cartItems || []).map((ci, i) => (
                        <ItemThumb key={i} item={ci} />
                    ))}
                </div>
            </div>
        );
    };

    /* ---------------- UI ---------------- */
    if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;
    if (error) return <p style={{ textAlign: "center" }}>{error}</p>;



    return (
        <>
            <Header />
            {/* Header */}


            {/* <div style={{ padding: 12, background: "#f6f7fb", minHeight: "100vh" }}>
        <button
          onClick={onRefresh}
          style={{
            marginBottom: 12,
            padding: "8px 16px",
            borderRadius: 6,
            border: "none",
            cursor: "pointer",
          }}
        >
          {refreshing ? "Refreshing..." : "Refresh"}
        </button>

        {orders.length === 0 ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            No paid orders yet.
          </div>
        ) : (
          orders.map(enrichOrder).map((o) => (
            <div key={o.id} style={{ marginBottom: 12 }}>
              <OrderCard order={o} />
            </div>
          ))
        )}
      </div> */}

            <div
                style={{
                    padding: 12,
                    background: "#f6f7fb",
                    minHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                }}
            >

                <div
                    style={{
                        width: "100%",
                        maxWidth: "900px",
                    }}
                >

                    <div
                        onClick={goBack}
                        style={{
                            background: "#ffffffff",
                            color: "#0058a3",
                            padding: "10px 0px",
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",


                        }}
                    >
                        <IoArrowBack size={22} />
                        <span style={{ marginLeft: 8, fontWeight: 600 }}>My Orders</span>
                    </div>
                    <button
                        onClick={onRefresh}
                        style={{
                            marginBottom: 12,
                            padding: "8px 16px",
                            borderRadius: 6,
                            border: "none",
                            cursor: "pointer",
                        }}
                    >
                        {refreshing ? "Refreshing..." : "Refresh"}
                    </button>

                    {orders.length === 0 ? (
                        <div style={{ textAlign: "center", padding: 40 }}>
                            No paid orders yet.
                        </div>
                    ) : (
                        orders.map(enrichOrder).map((o) => (
                            <div key={o.id} style={{ marginBottom: 12 }}>
                                <OrderCard order={o} />
                            </div>
                        ))
                    )}
                </div>
            </div>


            {/* Modal */}
            <Modal
                isOpen={!!selectedOrder}
                onRequestClose={() => setSelectedOrder(null)}
                style={{
                    content: {
                        inset: "10%",
                        borderRadius: 12,
                    },
                }}
            >
                <h2>Order #{selectedOrder?.id}</h2>

                {(selectedOrder?.cartItems || []).map((ci, i) => (
                    <div key={i} style={{ marginTop: 16 }}>
                        <b>{ci.name}</b>
                        <br />
                        <img src={ci.image} alt="" width={120} />
                        {ci.variant && (
                            <div>
                                Variant: {ci.variant.name} (₹{ci.variant.price})
                            </div>
                        )}
                        <div>Qty: {ci.quantity}</div>
                    </div>
                ))}

                <button
                    onClick={() => setSelectedOrder(null)}
                    style={{
                        marginTop: 20,
                        background: "#000",
                        color: "#fff",
                        padding: 12,
                        borderRadius: 8,
                        border: "none",
                        cursor: "pointer",
                    }}
                >
                    Close
                </button>
            </Modal>
        </>
    );
};

export default OrdersScreen;
